<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <documents></documents>
      </b-col>
    </b-row>
    <b-card>
      <b-row>
        <b-col sm="4">
          <label><strong style="color:#990000;font-size:large">Bibliothèque Prévoyance Collective</strong></label><br><br>
          <b-form-group>
            <template slot="label"><b>Secteur :</b></template>
            <b-form-radio-group id="radio-group-2-3" v-model="secteur" name="radio-secteur" @change="onChange()">
              <b-form-radio value="ess">ESS</b-form-radio>
              <b-form-radio value="interpro">INTERPRO</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <label><strong>Rechercher un document par famille produit</strong></label>
          <b-form-select v-model="selectedGamme" :options="gammesOptions" @change="showDocuments"></b-form-select>
        </b-col>
        <b-col sm="4"></b-col>
        <b-col sm="4" v-if="canCreateDocument()">
          <b-button type="button" @click="editDocument()" size="md" variant="success" class="pull-right">
            <i class="fa fa-plus"></i> Ajouter un document
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col sm="6">
          <b-row v-for="(rubrique, index) in rubriques" :key="'rubrique_L_'+index">
            <b-col sm="12" v-if="(index < 4 && selectedGamme !== null) || (index < 3 && selectedGamme === null)">
              <b-card no-body>
                <div class="card-smallHeader" :style="'background-color: '+rubrique.couleur">
                  <span style="font-size:small"><strong>{{ rubrique.libelle }}</strong></span>
                </div>
                <b-card-body class="small-padding">
                  <div v-for="sousRubrique in rubrique.sousRubriques" :key="'sr_'+sousRubrique.libelle">
                    <h6 class="mt-2 mb-0" v-if="!isEmpty(sousRubrique.libelle)" :style="'color: '+sousRubrique.couleur">{{ sousRubrique.libelle }}</h6>
                    <div v-for="doc in sousRubrique.docs" :key="doc.id">
                      <b-row>
                        <b-col sm="8">
                          <a v-if="!isEmpty(doc.chemin)" href="#" @click.prevent="downloadDocument(doc)">{{ doc.libelle }}</a>
                          <router-link v-else-if="!isEmpty(doc.url)" :to="openVideo(doc)" target="_blank"><span>{{ doc.libelle }}</span></router-link>
                          <span v-else>{{ doc.libelle }}</span>
                        </b-col>
                        <b-col sm="4" style="align-items: center;">
                          <span class="pull-right">
                            <i v-if="canEditDocument()" class="fa fa-edit fa-1_5x text-success clickable" @click="editDocument(doc)"></i>
                          </span>
                          <span class="pull-right mr-1"><i class="fa fa-eye fa-1_5x text-primary clickable" @click="showFicheDocument(doc)"></i></span>
                          <span class="pull-right mr-1"><i style="font-size:10px">{{ doc.lastMajFichier }}</i></span>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-row v-for="(rubrique, index) in rubriques" :key="'rubrique_R_'+index">
            <b-col sm="12" v-if="(index > 3 && selectedGamme !== null) || (index > 2 && selectedGamme === null)">
              <b-card no-body>
                <div class="card-smallHeader" :style="'background-color: '+rubrique.couleur">
                  <span style="font-size:small"><strong>{{ rubrique.libelle }}</strong></span>
                </div>
                <b-card-body class="small-padding">
                  <div v-for="sousRubrique in rubrique.sousRubriques" :key="'sr_'+sousRubrique.libelle">
                    <h6 class="mt-2 mb-0" v-if="!isEmpty(sousRubrique.libelle)" :style="'color: '+sousRubrique.couleur">{{ sousRubrique.libelle }}</h6>
                    <div v-for="doc in sousRubrique.docs" :key="doc.id">
                      <b-row>
                        <b-col sm="8">
                          <a v-if="!isEmpty(doc.chemin)" href="#" @click.prevent="downloadDocument(doc)">{{ doc.libelle }}</a>
                          <router-link v-else-if="!isEmpty(doc.url)" :to="openVideo(doc)" target="_blank"><span>{{ doc.libelle }}</span></router-link>
                          <span v-else>{{ doc.libelle }}</span>
                        </b-col>
                        <b-col sm="4" style="align-items: center;">
                          <span class="pull-right">
                            <i v-if="canEditDocument()" class="fa fa-edit fa-1_5x text-success clickable" @click="editDocument(doc)"></i>
                          </span>
                          <span class="pull-right mr-1"><i class="fa fa-eye fa-1_5x text-primary clickable" @click="showFicheDocument(doc)"></i></span>
                          <span class="pull-right mr-1"><i style="font-size:11px">{{ doc.lastMajFichier }}</i></span>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="!isEmpty(remarques[selectedGamme]) && secteur === 'ess'">
            <b-col sm="12">
              <div class="full-width p-1" style="background-color: #E6E0EC;" v-html="remarques[selectedGamme]"></div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/fileHelper";
import { downloadMixin } from "@/mixins/downloadMixin";
import Documents from "./documents/Documents";
import { espaceBibliothequeRules as rules, hasRule } from '@/utils/rulesHelper';

export default {
  name: "Accueil",
  mixins: [downloadMixin], // Injection de la méthode downloadDocument
  components: { Documents },
  data() {
    return {
      isEmpty,
      gammes: {},
      gammesOptions: [],
      rubriques: {},
      selectedGamme: 0,
      remarques: {},
      secteur: this.$route.query.secteur ? this.$route.query.secteur : 'ess',
      familleProduitId: this.$route.params.familleProduitId,
      rules,
      hasRule
    }
  },
  created() {
    if (!isEmpty(this.familleProduitId)) { this.selectedGamme = this.familleProduitId; }
    this.getGammes();
    this.fillRemarques();
  },
  methods: {
    onChange() { this.makeGammeOptions(); },
    getGammes() {
      this.$store.commit("IS_LOADING", true);
      this.$axios.get('/espaceBibliotheque/gammes')
        .then(async response => {
          this.allGammes = response.data.gammes;
          await this.makeGammeOptions();
          this.showDocuments();
          this.$store.commit("IS_LOADING", false);
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("IS_LOADING", false);
        });
    },
    showDocuments() {
      const foundGamme = this.allGammes.filter((gamme) => gamme.id == this.selectedGamme);
      this.selectedGamme = (!isEmpty(foundGamme) && foundGamme[0].id != 0) ? foundGamme[0].id : 0;
      this.rubriques = this.gammes[this.selectedGamme].orderedRubriques;
    },
    makeGammeOptions() {
      return new Promise(async resolve => {
        this.gammes = []; this.gammesOptions = []; this.rubriques = [];
        for (let gamme of this.allGammes) {
          if (gamme.secteur.includes(this.secteur)) {
            this.gammes[gamme.id] = gamme;
            this.gammes[gamme.id].orderedRubriques = [];
            this.gammesOptions.push({text: gamme.libelle, value: gamme.id});
          }
        }
        for await (let gamme of this.allGammes) {
          if (gamme.secteur.includes(this.secteur)) {
            let docsBySecteur = _.filter(gamme.documents, (doc) => doc.secteur === this.secteur);
            let docs = _.sortBy(docsBySecteur, (doc) => doc.ordre);
            docs.forEach(doc => {
              doc.lastMajFichier = doc.updated_at ? '(Màj: ' + new Date(doc.updated_at).toLocaleDateString("fr-FR") + ')' : "-";
            });

            let rubriques = _.groupBy(docs, (doc) => doc.rubrique.id);

            for (let index in rubriques) {
              let rubriqueDocs = _.sortBy(rubriques[index], doc => doc.sous_rubrique ? doc.sous_rubrique.libelle : -1);
              let sousRubriques = _.groupBy(rubriqueDocs, doc => doc.sous_rubrique ? doc.sous_rubrique.libelle : 0);
              let sousRubriqueDocs = [];
              for (let indexSousRubrique in sousRubriques) {
                sousRubriqueDocs.push({
                  libelle: sousRubriques[indexSousRubrique][0].sous_rubrique ? sousRubriques[indexSousRubrique][0].sous_rubrique.libelle : '',
                  couleur: sousRubriques[indexSousRubrique][0].sous_rubrique ? sousRubriques[indexSousRubrique][0].sous_rubrique.couleur : '',
                  docs: sousRubriques[indexSousRubrique]
                });
              }
              this.gammes[gamme.id].orderedRubriques.push({
                libelle: rubriques[index][0].rubrique.libelle,
                couleur: rubriques[index][0].rubrique.couleur,
                sousRubriques: sousRubriqueDocs
              });
            }
          }
        }
        resolve();
      });
    },

    showFicheDocument(document) { this.$eventBus.$emit('callShowFicheDocument', document);},
    editDocument(document) { this.$eventBus.$emit('callEditDocument', document); },
    formatDate(textDate) { return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-"; },
    openVideo(document) { return { path: '/espace-bibliotheque/document/video/' + document.url }; },

    fillRemarques() {
        // CCN 66
        this.remarques[1] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Depuis le 01/01/16 la seule condition pour entrer dans la mutualisation est d'appliquer la CCN 66 dans son intégralité (BS faisant foi).</li>
                                <li>Le contrat clone n'est plus ouvert à la vente. Les contrats en place seront progressivement basculés vers d'autres produits.</li>
                                <li>Les salariés TH des Entreprises Adaptées peuvent bénéficier du contrat CCN 66 sous réserve que l'établissement applique la convention collective dans son intégralité.</li>
                                <li>Les usagers d'ESAT ne peuvent pas bénéficier du contrat CCN 66; Le contrat Mutex-Handi est prévu à leur attention.</li>
                                <li>Les maitres-agréés ne peuvent cotiser que sur le salaire versé par l'établissement.</li>
                                <li>Les bascules entre opérateurs co-désignés font l'objet de règles particulières.</li>
                                <li>La reprise des REC est réalisée à titre gratuit pour les souscriptions dont la date d'effet est située entre le 01/01/16 et le 01/07/16</li>
                              </ul>`;

        // CCN Mutualité
        this.remarques[2] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>A l'exception de quelques structures, tous les employeurs de la branche sont adhérents à Chorum.</li>
                                <li>Depuis le 01-01-18, le contrat conventionnel concerne les Non-cadres et les Cadres en tranche A et B.</li>
                                <li>Les personnels professionnels de santé payés à l'acte, qui ne relèvent pas de la CCN Mutualité, ne doivent pas être affiliés au contrat conventionnel.</li>
                                <li>Ils peuvent en revanche être affiliés au contrat "Hors-Champ". Celui-ci n'est pas aligné sur les garanties de l'avenant 22. La TB est par ailleurs assurée par MM.</li>
                                <li>Les administrateurs mutualistes ne doivent pas être affiliés au régime, sauf s'ils sont salariés.</li>
                              </ul>`;

        // Mutualité HC
        this.remarques[3] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>A l'exception de quelques structures, tous les employeurs de la branche sont adhérents à Chorum.</li>
                                <li>Depuis le 01-01-18, le contrat conventionnel concerne les Non-cadres et les Cadres en tranche A et B.</li>
                                <li>Les personnels professionnels de santé payés à l'acte, qui ne relèvent pas de la CCN Mutualité, ne doivent pas être affiliés au contrat conventionnel.</li>
                                <li>Ils peuvent en revanche être affiliés au contrat "Hors-Champ". Celui-ci n'est pas aligné sur les garanties de l'avenant 22. La TB est par ailleurs assurée par MM.</li>
                                <li>Les administrateurs mutualistes ne doivent pas être affiliés au régime, sauf s'ils sont salariés.</li>
                              </ul>`;

        // Accord GHMF
        this.remarques[4] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Les personnels affiliés au contrat GHMF relèvent de la CCN FEHAP (mention sur leur bulletin de salaire) et sont salariés d'une structure hospitalière mutualiste.</li>
                                <li>Pour l'option TC, chaque salarié doit compléter un QMC.</li>
                              </ul>`;

        // CCN BAD
        this.remarques[5] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Co-désignation avec AG2R et Humanis.</li>
                                <li>Le contrat conventionnel ne respecte pas la CCN de 47; Pour les cadres, inviter les employeurs à souscrire l'additionnel Décès.</li>
                                <li>Les bascules entre opérateurs co-désignés sont réalisées hors REC jusqu'à la fin de la désignation.</li>
                              </ul>`;

        // CCN ALISFA
        this.remarques[6] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Les structures lucratives qui appliquent les dispositions de la CCN ALISFA dans leur intégralité peuvent exceptionnellement adhérer au régime. La mention de la CCN doit impérativement être stipulée sur les bulletins de salaire.</li>
                                <li>Utilisation relativement importante du CEA par les structures de cette CCN.</li>
                              </ul>`;

        // CCN ACI
        this.remarques[7] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Les ACI ne doivent pas être confondus avec les AI, EI et ETTI qui ne relèvent pas du champ d'application de la CCN.</li>
                              </ul>`;

        // CCN ECLAT
        this.remarques[8] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Chorum accepte les demandes d'adhésion sans contrainte géographique, sous réserve de répondre au périmètre conventionnel.</li>
                                <li>Depuis le 01/01/16, le régime conventionnel concerne les Non-Cadres et les Cadres.</li>
                                <li>Depuis le 01/01/16, le régime conventionnel est conforme aux obligations de la CCN de 47.</li>
                                <li>Utilisation relativement importante du CEA par les structures de cette CCN.</li>
                              </ul>`;

        // CCN Sport
        this.remarques[9] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Chorum accepte les demandes d'adhésion sans restriction géographique, sous réserve de répondre au périmètre conventionnel.</li>
                                <li>Le périmètre de la CCN accepte les structures lucratives comme les non-lucratives, mais pas les sportifs professionnels.</li>
                                <li>Pour les Cadres, Chorum propose une solution qui répond à la fois aux obligations conventionnelles et à la CCN de 47, constituée de 2 contrats (Base + Additionnel).</li>
                                <li>Utilisation très importante du CEA par les structures de cette CCN.</li>
                                <li>Gestion semestrielle des cotisations.</li>
                              </ul>`;

        // CCN TSF
        this.remarques[10] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Co-recommandation avec Humanis, tenant historique.</li>
                                <li>Le contrat conventionnel respecte la CCN de 47 depuis le 01-01-17.</li>
                              </ul>`;

        // CCN SAPPMA
        this.remarques[12] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>A compléter.</li>
                              </ul>`;

        // CCN Accord FR
        this.remarques[13] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Désignation exclusive Chorum.</li>
                                <li>Pour relever de l'accord, les structures doivent faire partie du mouvement Familles rurales.</li>
                                <li>Les taxis ne relèvent pas de cet accord.</li>
                                <li>Dans de nombreux départements, gestion centralisée au niveau de la fédération départementale.</li>
                              </ul>`;

        // Solutions FEHAP
        this.remarques[14] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>L'additionnel Décés SM51 est prétarifé en fonction de l'âge moyen des salariés.</li>
                                <li>Afin de respecter la CCN de 47, il est nécessaire pour les Cadres de souscrire un additionnel décès (solution SM51 proposée ou solution NOC TPE/PME).</li>
                                <li>Les structures de moins de 100 salariés bénéficient d'un produit FEHAP prétarifé, en fonction de la présence ou non de REC.</li>
                                <li>Les structures de 100 salariés ou plus, doivent faire l'objet d'une tarification; Plusieurs options sont possibles sur la franchise.</li>
                                <li>Les offres standard et SM51 ne sont pas réservées qu'aux structures adhérentes au syndicat Fehap ; la CCN 51 doit être appliquée intégralement.</li>
                              </ul>`;

        // Contrats CPM
        this.remarques[15] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>La Tranche B des cadres pour les contrats CPM 2000 et 2005 est le plus souvent assurée par Malakoff Mederic (cotisations et prestations gérées par Chorum).</li>
                                <li>Produits fermés à la vente; Un accord dérogatoire de Mutex est nécessaire pour toute opération contractuelle sur ces produits.</li>
                                <li>Par priorité envisager une bascule vers le contrat conventionnel approprié, vers les solutions Equilibre / Energie voire vers un Mutex Handi.</li>
                                <li>Dans tous les cas, s'assurer que les éventuelles obligations conventionnelles sont respectées.</li>
                              </ul>`;

        // Solutions TPE-PME
        this.remarques[16] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Le produit Chorum Prévoyance n'est plus ouvert à la vente depuis le 31/12/14.</li>
                                <li>Les solutions Equilibre et Energie ne sont plus ouverts à la vente depuis le 01/07/17.</li>
                                <li>Les solutions TPE - PME 2017 se substituent aux précédents produits.</li>
                                <li>Avant toute mise en place d'un contrat PME, vérifier l'éventuelle CCN applicable.</li>
                                <li>Utilisation fréquente du CEA par ces structures.</li>
                                <li>Les offres TPE et PME ne peuvent pas être commercialisées pour des adhérents appliquant intégralement une Convention gérée par Chorum, y compris la CCN Fehap.</li>
                              </ul>`;

        // Solutions ESAT
        this.remarques[17] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Ces contrats sont réservés aux usagers d'ESAT et ne concernent pas les salariés TH des Entreprises Adaptées.</li>
                                <li>Les contrats CNTH et Cap Handi ne sont plus ouverts à la vente.</li>
                              </ul>`;

        // Contrats Dédiés
        // this.remarques[18] = `<h6 style="color: #990000">Remarques :</h6>
        //                      <ul>
        //                       </ul>`;

        // Contrats SM & Divers
        this.remarques[19] = `<h6 style="color: #990000">Remarques :</h6>
                             <ul>
                                <li>Sont dans cette catégorie les contrats sur-mesure ainsi que les contrats de produits de faible volumétrie.</li>
                              </ul>`;

        // Accord CHRS
        // this.remarques[22] = `<h6 style="color: #990000">Remarques :</h6>
        //                      <ul>
        //                       </ul>`;

        // CCN Missions Locales / PAIO
        // this.remarques[57] = `<h6 style="color: #990000">Remarques :</h6>
        //                      <ul>
        //                       </ul>`;

        // CCN SYNTEC
        // this.remarques[58] = `<h6 style="color: #990000">Remarques :</h6>
        //                      <ul>
        //                       </ul>`;

        // CCN HLA
        // this.remarques[59] = `<h6 style="color: #990000">Remarques :</h6>
        //                      <ul>
        //                       </ul>`;

      },
      canEditDocument() {return hasRule(rules.CAN_EDIT_DOCUMENT);},
      canCreateDocument() {return hasRule(rules.CAN_CREATE_DOCUMENT);}
    }
  }
</script>

<style scoped>
.my-header {
  color: #FFFFFF !important;
}
</style>
